export default "__VITE_ASSET__BiaxlgH9__"